import React from 'react'
import { Form, FormGroup, Input, InputGroup, Label, Alert } from 'reactstrap'
import PropTypes from 'prop-types'
import { solidRate } from '../../../formulas/solidRate'
import { densityCorrection } from '../../../formulas/densityCorrection'

export default class SolidRateForm extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            hasResult: false,
            hasError: false,
            error: ''
        }
    }

    handleChange = (e) => {
        const target = e.target
        this.props.formToState({ [target.name]: parseFloat(target.value) }) // Redux
    }

    changeGypsum = (e) => {
        e.preventDefault()
        const target = e.target
        this.props.formToState({ gypsumConstant: parseFloat(target.value) }) // Redux
    }

    calculateSolidRate = (e) => {
        e.preventDefault()
        e.stopPropagation()
        try {
            const { correctedDensity } = densityCorrection(this.props.formValues.tFiltrate, this.props.formValues.dFiltrate, this.props.formValues.tPorridge) // First, density correction of filtrate
            const result = solidRate(correctedDensity, this.props.formValues.dPorridge, this.props.formValues.gypsumConstant) // Then, solid rate with the corrected dfiltrate
            this.props.formToState({ result }) // Redux
            this.setState({ hasResult: true, hasError: false })
        } catch (error) {
            this.setState({ hasResult: false, hasError: true, error: 'Impossible calculation !' })
        }
    }

    render() {
        return (
            <Form onSubmit={this.calculateSolidRate}>
                <FormGroup>
                    <InputGroup>
                        <div className="col-md-8">
                            <Label for="dFiltrate">Filtrate density <b>(kg/L)</b></Label>
                        </div>
                        <div className="col-md-4">
                            <Input step="0.0001" required type="number" name="dFiltrate" id="dFiltrate" onChange={this.handleChange} />
                        </div>
                    </InputGroup>
                    <br />
                    <InputGroup>
                        <div className="col-md-8">
                            <Label for="tFiltrate">Filtrate temperature <b>(°C)</b></Label>
                        </div>
                        <div className="col-md-4">
                            <Input step="0.0001" required type="number" name="tFiltrate" id="tFiltrate" onChange={this.handleChange} />
                        </div>
                    </InputGroup>
                    <br />
                    <InputGroup>
                        <div className="col-md-8">
                            <Label for="dPorridge">Slurry density <b>(kg/L)</b></Label>
                        </div>
                        <div className="col-md-4">
                            <Input step="0.0001" required type="number" name="dPorridge" id="dPorridge" onChange={this.handleChange} />
                        </div>
                    </InputGroup>
                    <br />
                    <InputGroup>
                        <div className="col-md-8">
                            <Label for="tPorridge">Slurry temperature <b>(°C)</b></Label>
                        </div>
                        <div className="col-md-4">
                            <Input step="0.0001" required type="number" name="tPorridge" id="tPorridge" onChange={this.handleChange} />
                        </div>
                    </InputGroup>
                    <br />
                    {/** GYPSUM TYPE */}
                    <InputGroup>
                        <div className="col-md-4">
                            <Label for="gypsumConstant">Gypsum</Label>
                        </div>
                        <div className="col-md-8">
                            <select name="gypsumConstant" className="form-control" onChange={this.changeGypsum}>
                                <option value={2.32}>Dihydrate gypsum</option>
                                <option value={2.72}>Hemihydrate gypsum</option>
                            </select>
                        </div>
                    </InputGroup>
                </FormGroup>
                <br />
                <Input type="submit" value="Calculate solid fraction" className="custom-button" onClick={this.calculateSolidRate} />
                <br />
                {/** Résultat */}
                {this.state.hasResult ?
                    <div className="formula-result text-center">
                        Solid fraction is {this.props.formValues.result} %
                    </div>
                    : null}
                {/** Erreur */}
                {this.state.hasError ?
                    <div className="text-center">
                        <Alert color="danger">{this.state.error}</Alert>
                    </div>
                    : null}
            </Form>
        )
    }
}
SolidRateForm.propTypes = {
    formValues: PropTypes.shape({
        dFiltrate: PropTypes.number,
        tFiltrate: PropTypes.number,
        dPorridge: PropTypes.number,
        tPorridge: PropTypes.number,
    }),
    formToState: PropTypes.func
}